import React from 'react';
import {
  PictureAsPdf as PictureAsPdfIcon,
  Article as ArticleIcon,
  TextSnippet as TextSnippetIcon,
  InsertDriveFile as InsertDriveFileIcon,
} from '@mui/icons-material';

/**
 * Get user-friendly file type name from MIME type or file extension
 */
export const getFileTypeName = (fileType: string): string => {
  if (fileType.includes('pdf')) {
    return 'PDF';
  } else if (fileType.includes('vnd.openxmlformats-officedocument.wordprocessingml.document')) {
    return 'DOCX';
  } else if (fileType.includes('msword') || fileType.includes('doc')) {
    return 'DOC';
  } else if (fileType.includes('text/plain') || fileType.includes('txt')) {
    return 'TXT';
  } else if (fileType.includes('image/')) {
    return 'Image';
  } else if (fileType.includes('text/')) {
    return 'Text';
  }
  return 'Document';
};

/**
 * Render file type icon based on MIME type or file extension
 */
export const renderFileTypeIcon = (fileType: string, sx?: object): React.ReactElement => {
  const iconSx = sx || {};
  
  if (fileType.includes('pdf')) {
    return <PictureAsPdfIcon color="error" sx={iconSx} />;
  } else if (fileType.includes('word') || fileType.includes('doc')) {
    return <ArticleIcon color="primary" sx={iconSx} />;
  } else if (fileType.includes('text') || fileType.includes('txt')) {
    return <TextSnippetIcon color="success" sx={iconSx} />;
  }
  return <InsertDriveFileIcon sx={iconSx} />;
};

/**
 * Format date to locale string with both date and time
 */
export const formatDate = (dateString: string, locale: string = 'en-US'): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString(locale) + ' ' + date.toLocaleTimeString(locale);
}; 